'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var isProduction = {
  development: {
    isProduction: false
  },
  mock: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || global.window && global.window.env.env || 'development'];

var environment = process.env.ENV || global.window && global.window.env.env_bf || 'env3';
// hack for prop type warning due to older version of react and some dependencies using prop types
if (environment !== 'prod') {
  (function () {
    var _error = console.error;
    console.error = function (errMessage) {
      var check = errMessage && errMessage.indexOf('Warning: Failed Context Types: Calling PropTypes validators directly is not supported by the') !== -1;
      if (!check) {
        _error.call(console, errMessage);
      }
    };
  })();
}
module.exports = (0, _assign2.default)(process.env.ENV ? {
  host: process.env.HOST || 'localhost',
  port: process.env.PORT || 443,
  env: process.env.NODE_ENV || 'development', //  production or development
  env_bf: environment,
  local: process.env.LOCAL || true,
  domain: process.env.DOMAIN || environment + '.consumerism.pressganey.com',
  apiHost: process.env.APIHOST || 'localhost', // mock API
  apiPort: process.env.APIPORT,
  devHost: process.env.DEVHOST || 'feedback-api.' + environment + '.consumerism.pressganey.com',
  nextgenHost: process.env.NEXTGENHOST || 'reputation.' + environment + '.consumerism.pressganey.com',
  nextgenApiHost: process.env.NEXTGENAPIHOST || 'nextgenbha-api.' + environment + '.consumerism.pressganey.com',
  notificationHost: process.env.NOTIFICATIONHOST || 'notification-api.' + environment + '.consumerism.pressganey.com',
  devPort: 443,
  loginHost: process.env.LOGINHOST || 'login.' + environment + '.consumerism.pressganey.com',
  idleTime: process.env.IDLE_TIME || 15,
  app: {
    title: 'Press Ganey Consumer Experience',
    description: 'Press Ganey Consumer Experience',
    head: {
      titleTemplate: '%s - Press Ganey Consumer Experience',
      meta: [{ name: 'description', content: 'binary' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'binary' }, { property: 'og:image', content: 'binary' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'binary' }, { property: 'og:description', content: 'binary' }, { property: 'og:card', content: 'binary' }, { property: 'og:site', content: 'binary' }, { property: 'og:creator', content: 'binary' }, { property: 'og:image:width', content: '200' }, { property: 'og:image:height', content: '200' }]
    }
  }

} : (0, _assign2.default)({}, global.window && global.window.env), isProduction);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 273
// module chunks = 0